import { createSlice } from "@reduxjs/toolkit";

/** Async Thunks */


/** Initial State */

const initialState = {
  renew: false,
  licenceYears: 0,
  totalCost: 60,
  currency: 'EUR',
  tempOrderId: "",
  licenceCode: "",
  licenceToRenew: null,
  buyStep: "invoiceForm",
  invoiceData: {},
  country: "IT",
  countryType: "italy"
};

/** Slice */

export const licencesSlice = createSlice({
  name: "licences",
  initialState,
  reducers: {
    invoiceFormSent: (state, action) => {
      state.invoiceData = action.payload;
      state.buyStep = "payment";
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setCountryType: (state, action) => {
      state.countryType = action.payload;
    },
    resetBuyProcedure: (state, action) => {
      state.buyStep = "invoiceForm";
      state.invoiceData = {};
      state.licenceToRenew = "";
      state.renew = false;
    },
    setLicenceToRenew: (state, action) => {
      state.buyStep = "invoiceForm";
      state.invoiceData = {};
      state.renew = true;
      state.licenceToRenew = action.payload;
    },
    setLicenceYears: (state, action) => {
      state.licenceYears = action.payload;
    },
    setTotalCost: (state, action) => {
      state.totalCost = action.payload;
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setTempOrderId: (state, action) => {
      state.tempOrderId = action.payload;
    },
    setLicenceCode: (state, action) => {
      state.licenceCode = action.payload;
    },
    getTempOrderId: (state) => {
      return state.tempOrderId;
    }
  }
});

export const { invoiceFormSent, setCountry, setCountryType, resetBuyProcedure, setLicenceToRenew, setLicenceYears, setTotalCost, setCurrency, setTempOrderId, setLicenceCode, getTempOrderId } = licencesSlice.actions;
export default licencesSlice.reducer;